<template>
  <div class="container mx-auto filter-container">
    <p class="font-bold mb-4">Status :</p>
    <div class="radio-filter-container">
      <label
        class="cursor-pointer w-full mb-2 inline-flex items-center ml-6"
        v-for="(status, index) in statuses"
        :key="index"
      >
        <input v-model="localFilterStatus" type="radio" class="form-radio" :value="status.value" name="frequency" />
        <span class="ml-2">{{ status.label }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterTargetedContent',

  props: {
    filterStatus: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      localFilterStatus: this.filterStatus,
      statuses: [
        { value: 'all', label: 'All' },
        { value: 'enable', label: 'Enable' },
        { value: 'terminated', label: 'Terminated' },
        { value: 'pending', label: 'Pending' },
        { value: 'disable', label: 'Disable' }
      ]
    }
  },

  watch: {
    filterStatus(newVal) {
      this.localFilterStatus = newVal
    },
    localFilterStatus() {
      this.filterItem()
    }
  },

  methods: {
    filterItem() {
      this.$emit('filter-item', this.localFilterStatus)
    }
  }
}
</script>

<style>
.filter-container {
  display: flex;
  flex-direction: row;
}
.radio-filter-container {
  display: flex;
  flex-flow: column wrap;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/form/filter-targeted-content.vue